import { render, staticRenderFns } from "./addshopCategory.vue?vue&type=template&id=312fad8d&scoped=true"
import script from "./addshopCategory.vue?vue&type=script&lang=js"
export * from "./addshopCategory.vue?vue&type=script&lang=js"
import style0 from "./addshopCategory.vue?vue&type=style&index=0&id=312fad8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312fad8d",
  null
  
)

export default component.exports